import { scrollIntoView } from '../scroll-into-view/scroll-into-view';
import { isAny } from '../mobile-detect/mobile-detect';

let initialized = false;

export const imageTooltipSetup = () => {
    const image = document.querySelector<HTMLImageElement>('.image-tooltip img');
    if (!image) return;

    const initHotspots = () => {
        if (initialized) return;
        initialized = true;
        setUpListeners();
    };

    if (image.complete && image.naturalHeight !== 0) {
        initHotspots();
    } else {
        image.addEventListener('load', initHotspots);
    }
};

const setUpListeners = () => {
    const hotspots = document.querySelectorAll<HTMLElement>('.hotspot');
    const scrollButton = document.querySelector<HTMLAnchorElement>('.js-scroll-to-dimensions');
    const dimensionsArea = document.querySelector<HTMLElement>('#productDimensions');

    if (scrollButton && dimensionsArea) {
        scrollButton.addEventListener('click', (e) => {
            e.preventDefault();
            scrollIntoView(dimensionsArea, { scrollUp: 80, scrollDown: 80 });
        });
    }

    if (!hotspots || hotspots.length === 0) return;

    hotspots.forEach(hotspot => {
        convertHotspotToPercentages(hotspot);

        if (!isAny()) return;

        hotspot.addEventListener('click', (e) => {
            e.stopPropagation();
            hotspots.forEach(h => h?.classList?.remove('active'));
            hotspot?.classList?.add('active');
        });
    });

    document.addEventListener('click', () => {
        hotspots.forEach(h => h?.classList?.remove('active'));
    });
};

const convertHotspotToPercentages = (hotspotElement: HTMLElement) => {
    const container = hotspotElement.closest<HTMLElement>('.image-tooltip');
    const image = container?.querySelector<HTMLImageElement>('img');
    if (!container || !image) return;

    const containerWidth = container.offsetWidth;
    const containerHeight = container.offsetHeight;

    if (containerHeight === 0) {
        // Retry after layout settles
        requestAnimationFrame(() => convertHotspotToPercentages(hotspotElement));
        return;
    }

    let dataX = parseFloat(hotspotElement.getAttribute('data-x') ?? '');
    let dataY = parseFloat(hotspotElement.getAttribute('data-y') ?? '');

    if (isNaN(dataX) || isNaN(dataY)) {
        console.error("Invalid data-x or data-y for hotspot", hotspotElement);
        return;
    }

    // Responsive scaling using actual image natural size
    const scaleX = containerWidth / image.naturalWidth;
    const scaleY = containerHeight / image.naturalHeight;

    dataX *= scaleX;
    dataY *= scaleY;

    const leftPercent = (dataX / containerWidth) * 100;
    const topPercent = (dataY / containerHeight) * 100;

    hotspotElement.style.left = `${leftPercent.toFixed(2)}%`;
    hotspotElement.style.top = `${topPercent.toFixed(2)}%`;

    hotspotElement.classList.remove('hidden');

    if (isAny()) applyTooltipEdgeClasses(hotspotElement);
};

function applyTooltipEdgeClasses(hotspotElement: HTMLElement) {
    const container = hotspotElement.closest<HTMLElement>('.image-tooltip');
    const tooltip = hotspotElement.querySelector<HTMLElement>('.tooltip');
    if (!container || !tooltip) return;

    tooltip.classList.remove('move-left', 'move-right');

    const containerRect = container.getBoundingClientRect();
    const hotspotRect = hotspotElement.getBoundingClientRect();

    const distanceFromLeft = hotspotRect.left - containerRect.left;
    const distanceFromRight = containerRect.right - hotspotRect.right;

    if (distanceFromRight < 75) tooltip.classList.add('move-left');
    else if (distanceFromLeft < 75) tooltip.classList.add('move-right');
}
